import { render, staticRenderFns } from "./TaskChangelog.vue?vue&type=template&id=6cd52e3f&scoped=true"
import script from "./TaskChangelog.vue?vue&type=script&lang=js"
export * from "./TaskChangelog.vue?vue&type=script&lang=js"
import style0 from "./TaskChangelog.vue?vue&type=style&index=0&id=6cd52e3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd52e3f",
  null
  
)

export default component.exports